module.exports = __webpack_public_path__ + "static/media/star-road.8ee2e0c7.png";